export interface BrowserTraceContext {
  traceparent: string
  traceId: string
  spanId: string
  sampled: boolean
}

const traceparentPattern = /^00-((?!0{32})[0-9a-f]{32})-((?!0{16})[0-9a-f]{16})-([0-9a-f]{2})$/

function randomHex(byteLength: number): string {
  const bytes = new Uint8Array(byteLength)
  globalThis.crypto.getRandomValues(bytes)
  if (bytes.every((value) => value === 0)) bytes[bytes.length - 1] = 1
  return Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('')
}

export function parseTraceparent(value: string | null | undefined): BrowserTraceContext | null {
  const match = traceparentPattern.exec(value ?? '')
  if (!match) return null
  return {
    traceparent: value as string,
    traceId: match[1] as string,
    spanId: match[2] as string,
    sampled: (Number.parseInt(match[3] as string, 16) & 1) === 1,
  }
}

export function createTraceparent(): BrowserTraceContext {
  const traceId = randomHex(16)
  const spanId = randomHex(8)
  return {
    traceparent: `00-${traceId}-${spanId}-00`,
    traceId,
    spanId,
    sampled: false,
  }
}
